import { v4 } from 'uuid';
import { gacsTicketFetcher } from 'GlobalAppConfigService';

interface ValidateAndFetchAppConfigurationUsingTokenParams {
	storeurl?: string;
	appConfigServiceTokenRequired: (params: { storeurl: string }) => Promise<{
		isTokenRequired: boolean;
	}>;
	appConfigServiceFetchWithToken: (params: {
		accesstoken: string;
		metadata: string;
		transactionid: string;
		storeurl: string;
	}) => Promise<any>;
}

export async function validateAndFetchAppConfigurationUsingToken(
	params: ValidateAndFetchAppConfigurationUsingTokenParams
) {
	const { storeurl, appConfigServiceTokenRequired, appConfigServiceFetchWithToken } =
		params;
	const resp = await appConfigServiceTokenRequired({
		storeurl,
	});
	if (!resp?.isTokenRequired) {
		return;
	}
	const gacsParamsJSON = await gacsTicketFetcher.getGacsParamsJSON();
	if (!gacsParamsJSON) {
		return;
	}
	const { access: accesstoken, metadata } = gacsParamsJSON;
	await appConfigServiceFetchWithToken({
		accesstoken,
		metadata,
		transactionid: v4(),
		storeurl,
	});
}
